import React from "react";
import SectionCommonTable from "../../components/SectionCommonTable";
import MyTopupHistoryTable from "./table/myTopupHistoryTable";

const MyTopupHistoryPage = () => {
  return (
    <SectionCommonTable
      wrapperClassName="mytopuphistory_table"
      cardStyle={{ backgroundColor: "#fff" }}
      sectionTableTitle="My Topup History"
      table={<MyTopupHistoryTable />}
    />
  );
};

export default MyTopupHistoryPage;
